<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12>
        <div v-if="loaded">
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 lg6>
                <v-select :items="orgs" v-model="org" label="HC Organization" autocomplete
                          item-text="name" item-value="id" return-object v-if="loaded"/>
              </v-flex>
              <v-flex xs12 lg6>
                <v-select :items="realizations" v-model="sppdEmployee" label="Employee Business Trip Request"
                          autocomplete item-text="_displayName" item-value="id" return-object />
              </v-flex>
              <v-flex xs12>
                <v-btn :to="{name: 'business-trip-new-realization',
                            params: {org: org, sppd: sppdEmployee, backRoute: {name: $route.name}}}"
                       v-if="realizationSelected">Next</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
        <h2 v-else>Loading...</h2>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Vuex from 'vuex'

const organizationStore = Vuex.createNamespacedHelpers('Organization')
const btRealizationStore = Vuex.createNamespacedHelpers('BusinessTripRealization/Realization')

export default {
  name: 'BtRealizationSelectSppd',
  data () {
    return {
      title: 'Select SPPD',
      org: {},
      realizations: [],
      sppdEmployee: {},
      loaded: false,
      actions: [
        {tooltip: 'Close', icon: 'exit_to_app', to: {name: 'business-trip-realization-list'}}
      ]
    }
  },
  computed: {
    ...organizationStore.mapState({
      orgs: 'authItems'
    }),
    realizationSelected () {
      return (typeof this.org.id !== 'undefined' && this.org.id !== '') &&
        (typeof this.sppdEmployee.id !== 'undefined' && this.sppdEmployee.id !== '')
    }
  },
  watch: {
    org (newValue, oldValue) {
      const self = this
      if (typeof newValue.id !== 'undefined' && newValue.id !== '') {
        self.getEmployeeRealizationsByOrg({vueinstance: self, orgid: newValue.id})
          .then(res => {
            const realizations = res.map(x => {
              return {
                ...x,
                _displayName: x.employee.name + ' (' + x.employee.nik + ') - ' + x.sppd.batchNo
              }
            })
            self.realizations = realizations
          })
          .catch(err => self.$error(err))
      }

      if (typeof oldValue !== 'undefined') {
        self.sppdEmployee = {}
      }
    }
  },
  methods: {
    ...organizationStore.mapActions({
      listAuthorizedOrgs: 'listAuthorized'
    }),
    ...btRealizationStore.mapActions({
      getEmployeeRealizationsByOrg: 'getEmployeeRealizationsByOrg'
    }),
    loadResources () {
      const self = this
      this.listAuthorizedOrgs({vueinstance: this})
        .then(res => {
          self.loaded = true
        })
    },
    _setupToolBar () {
      this.$store.dispatch('setTitle', {title: this.title})
      this.$store.dispatch('Action/setActions', this.actions)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.loadResources()
      vm._setupToolBar()
    })
  },
  beforeRouteUpdate (to, from, next) {
    this.loadResources()
    this._setupToolBar()
    next()
  },
  beforeRouteLeave (to, from, next) {
    this.loaded = false
    this._setupToolBar()
    next()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/bt-realization/BtRealizationSelectSppd.vue